import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { trafficVehicleStayPCL } = useReportFiltersFetch({ fetchTrafficVehicleStayPCL: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <SelectComponent
                        id="pcl"
                        label='Ponto de coleta *'
                        isMulti={true}
                        wrapValues={true}
                        options={trafficVehicleStayPCL}
                        value={filters.pcl}
                        onChange={(value) => setFilters(prev => ({...prev, pcl: value}))}
                        classNameWrapper={"w-full"}
                    />
                </form>
            </div>
        </>
    );
};

export default Filters;